import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, Button, Stack, Typography } from "@mui/material";

import { SearchField } from "@/common/components/search-field/SearchField";
import { DataTable } from "@/common/components/table/DataTable";
import { UserPermission } from "@/common/contexts/current-user-context/CurrentUserContextProvider.types";
import withAuthorization from "@/common/hocs/with-authorization/withAuthorization";
import { systemSettingsPath } from "@/router/SystemSettingsRoutes";
import { useTranslation } from "@/translations";

import { VolunteerCreationDialog } from "./components/create-volunteer/VolunteerCreationDialog";
import { useVolunteers } from "./hooks/useVolunteers";

function VolunteersInner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { volunteers, hasAdditionalVolunteers, isLoading, columns, searchText, setSearchText } = useVolunteers();

  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  return (
    <Stack spacing={1} sx={{ height: "100%" }} overflow={"hidden"}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <SearchField
          placeholder={t("volunteers.searchPlaceholder")}
          initialValue={searchText}
          onChange={setSearchText}
          width="70%"
        />
        <Button variant="contained" onClick={() => setIsCreateDialogOpen(true)}>
          {t("volunteers.createButton")}
        </Button>
      </Box>
      {!isLoading && hasAdditionalVolunteers && (
        <Typography variant="subtitle1">{t("volunteers.moreResults")}</Typography>
      )}
      {volunteers.length === 0 && !isLoading ? (
        <Typography sx={{ whiteSpace: "pre-wrap" }}>{t("volunteers.noResults")}</Typography>
      ) : (
        <Stack
          sx={{
            overflow: "auto",
            flex: 1,
            minHeight: 0,
          }}
        >
          <DataTable
            data={volunteers}
            columns={columns}
            getRowId={(row) => row.volunteerId}
            onRowClick={(id) => void navigate(systemSettingsPath.byVolunteerId({ id }))}
            paginationResetKey={searchText}
          />
        </Stack>
      )}
      {isCreateDialogOpen && <VolunteerCreationDialog onClose={() => setIsCreateDialogOpen(false)} />}
    </Stack>
  );
}

export const Volunteers = withAuthorization(VolunteersInner, UserPermission.Supervisor);
